<header class="site-header">

    <div class="header-shell">

        <div class="header-bar">

            <a class="brand" routerLink="/" aria-label="International Student Community Club — home">
                <img src="assets/header/logo.png" alt="International Student Community Club" width="132"
                    height="39" />
            </a>

            <nav class="nav-group" aria-label="Main">

                <ul class="nav-links">
                    @for (link of navLinks; track link.fragment) {
                    <li>
                        <a routerLink="/" [fragment]="link.fragment">{{ link.label }}</a>
                    </li>
                    }
                </ul>

                @if (auth.isAuthenticated()) {
                <button type="button" class="btn-login" (click)="logout()">
                    <span>Log Out</span>
                    <img src="assets/header/icon-arrow-up-right.svg" alt="" aria-hidden="true" width="16"
                        height="16" />
                </button>
                } @else {
                <a class="btn-login" routerLink="/login">
                    <span>Log In</span>
                    <img src="assets/header/icon-arrow-up-right.svg" alt="" aria-hidden="true" width="16"
                        height="16" />
                </a>
                }

            </nav>

            <button type="button" class="nav-toggle" [class.is-open]="menuOpen()" [attr.aria-expanded]="menuOpen()"
                aria-controls="header-mobile-menu" aria-label="Toggle navigation menu" (click)="toggleMenu()">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </button>

        </div>

        <div id="header-mobile-menu" class="mobile-menu" [class.is-open]="menuOpen()" [attr.inert]="menuOpen() ? null : ''">

            <ul class="mobile-links">
                @for (link of navLinks; track link.fragment) {
                <li>
                    <a routerLink="/" [fragment]="link.fragment" (click)="closeMenu()">{{ link.label }}</a>
                </li>
                }
            </ul>

            @if (auth.isAuthenticated()) {
            <button type="button" class="btn-login" (click)="logout()">
                <span>Log Out</span>
                <img src="assets/header/icon-arrow-up-right.svg" alt="" aria-hidden="true" width="16"
                    height="16" />
            </button>
            } @else {
            <a class="btn-login" routerLink="/login" (click)="closeMenu()">
                <span>Log In</span>
                <img src="assets/header/icon-arrow-up-right.svg" alt="" aria-hidden="true" width="16"
                    height="16" />
            </a>
            }

        </div>

    </div>

</header>

<app-logout-dialog />
